// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accordion[data-v-6032c211] {\n  --magic-accordion-toggle-background: var(--magic-tertiary, #311261);\n  color: var(--magic-light, #fff);\n}\n\n.description[data-v-6032c211] {\n  color: var(--magic-tertiary, #311261);\n}\n\n.free-spins-card[data-v-6032c211] {\n  --magic-header: var(--magic-light, #fff);\n  background-color: var(--magic-tertiary, #311261);\n  color: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
